(() => {
  if (!document.querySelector('iframe[data-tally-src]')) return;
  const load = () => {
    if (window.Tally) window.Tally.loadEmbeds();
    else document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach(frame => { frame.src = frame.dataset.tallySrc; });
  };
  const src = 'https://tally.so/widgets/embed.js';
  if (window.Tally) load();
  else if (!document.querySelector(`script[src="${src}"]`)) {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = load;
    script.onerror = load;
    document.body.appendChild(script);
  } else load();
  document.addEventListener('shopify:section:load', load);
})();

